import React from "react";
import { makeStyles } from "@mui/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Technology from "./Technology";
import Configurations from "./Configurations";
import Schedule from "./Schedule";
import Notification from "./Notification";
// import Budget from "./Budget";
import BudgetError from "./BudgetError";
import { Card, Box, Container, CardContent, Tooltip } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { Helmet } from "react-helmet";
import Review from "./Review";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  stepper: {
    color: "green",
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },

  addbuttons: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 30px",
    paddingLeft: 10,
  },
}));

export default function RequestLayout() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);

    setState((prevState) => ({
      ...prevState,
      email: "",
      guacmoleLabState: "",
      selectedRelatedLabType: "",
      selectedMasterLabId: "",
      selectedMasterOrRelatedLab: "",
      feedback: "",
      feedbackno: "",
      selectedDates: [],
      manageState: "",
      env_keep_date: "",
      meetingLink: "",
      disable_copypaste: "",
      identicalpassword: "",
    }));
  };

  const steps = [
    "General Info",
    "Configure Machines",
    "Schedule",
    "Parameters",
    "Review",
    // "Budget",
  ];

  const [lablist, setlablist] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/sharedvmlablist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setlablist(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [budgetopen, setBudgetOpen] = React.useState(false);

  const [state, setState] = React.useState({
    name: "",
    description: "",
    customized_variable: "",
    billing_info: "",
    commands: "",
    application: "sharedvm",
    cpu_count: "",
    start_date_time: "",
    end_date_time: "",
    start_time: "",
    end_time: "",
    start_date: "",
    end_date: "",
    startcron_expression: "",
    stopcron_expression: "",
    startcron_expression2: "",
    stopcron_expression2: "",
    budget: "",
    env_keep: "",
    delete_id: "",
    errorMessage: "",
    feedbackState: "",
    feedbackno: "",
    selectedDates: "",
    meetingLink: "",
    budgethours: 0,
    billingtype: "budgetbased",
    disable_copypaste: "",
    guacmoleLabState: "",
    selectedMasterOrRelatedLab: "",
    selectedMasterLab: "",
    budgetStorageHours: 0,
    hourlyBasedAmount: 0,
    selectedRelatedLabType: "",
    selectedMasterLabId: "",
    identicalpassword: "",
  });

  const handleSubmitClick = (e) => {
    e.preventDefault();
    handleNext();
    var addvalue = state.customized_variable;
    addvalue.lab_name = state.name;
    addvalue.Application_Name = state.application;
    addvalue.master_count = state.nooftrainee;
    addvalue.node_count = state.nooftrainee;
    delete addvalue["cpu_count"];

    var addvalue1 = state.billing_info;
    addvalue1.lab_name = state.name;
    addvalue1.master_count = state.nooftrainee;

    var finalEmail;
    if (state.email) {
      finalEmail = state.email;
    } else {
      finalEmail = localStorage.getItem("email");
    }
    // addvalue.start_time = state.startcron_expression;
    // addvalue.stop_time = state.stopcron_expression;
    var value = JSON.stringify(addvalue);
    var value1 = JSON.stringify(addvalue1);
    var env_keep;
    if (state.env_keep) {
      env_keep = "yes";
    } else {
      env_keep = "no";
    }

    var fbState;
    if (state.feedbackno && state.selectedDates) {
      fbState = "Yes";
    } else {
      fbState = "No";
    }

    var manageState;
    if (state.manageState && state.depends_on === "during_training") {
      manageState = "yes";
    } else {
      manageState = "no";
    }

    var disableCopyPasteState;
    if (state.disable_copypaste) {
      disableCopyPasteState = "yes";
    } else {
      disableCopyPasteState = "no";
    }

    var boolIdenticalPassword;
    if (state.identicalpassword) {
      boolIdenticalPassword = "yes";
    } else {
      boolIdenticalPassword = "no";
    }

    var guacmoleLab;
    var master_or_realated;
    if (state.guacmoleLabState) {
      guacmoleLab = "yes";
      // if(state.selectedMasterOrRelatedLab === "master"){
      //   guacmoleLab = "no";
      // }
      // master_or_realated = state.selectedMasterOrRelatedLab
      master_or_realated = "related";
    } else {
      guacmoleLab = "no";
      master_or_realated = "master";
    }

    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const instancedata = {
      name: state.name,
      number_of_trainee: state.nooftrainee,
      description: state.description,
      application: state.application,
      customized_variable: value,
      billing_info: value1,
      commands: state.commands,
      start_date: state.start_date,
      end_date: state.end_date,
      start_time: state.start_time,
      stop_time: state.end_time,
      time_zone: timezone,
      depends_on: state.depends_on,
      repeat_frequency: state.repeat_frequency,
      every: state.every,
      on_days: state.on_days,
      startcron_expression: state.startcron_expression,
      stopcron_expression: state.stopcron_expression,
      startcron_expression2: state.startcron_expression2,
      stopcron_expression2: state.stopcron_expression2,
      cpu_count: state.cpu_count,
      email: finalEmail,
      budget: state.budget,
      env_keep: env_keep,
      feedback: fbState,
      feedback_no: state.feedbackno,
      feedBack_date: state.selectedDates,
      manage_labs: manageState,
      env_keep_date: state.env_keep_date,
      meeting_url: state.meetingLink,
      budgethours: state.budgethours,
      billingtype: state.billingtype,
      disable_copypaste_guac: disableCopyPasteState,
      budgetStorageHours: state.budgetStorageHours,
      hourlyBasedAmount: state.hourlyBasedAmount,
      selectedRelatedLabType: state.selectedRelatedLabType,
      selectedMasterLabId: state.selectedMasterLabId,
      guacmoleLabState: guacmoleLab,
      selectedMasterOrRelatedLab: master_or_realated,
      identicalPassword: boolIdenticalPassword,
      // guacmoleLabState: guacmoleLab,
      // selectedMasterOrRelatedLab: state.selectedMasterOrRelatedLab,
      // selectedMasterLab: state.selectedMasterLab,
    };
    // console.log(JSON.stringify(instancedata));

    // console.log("Customized variable", value)
    fetch(`${process.env.REACT_APP_API_URL}/api/sharedvmlabs/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(instancedata),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.name) {
          window.location.href = "/app/instance/sharedvm";
        } else {
          if (data.name) {
            setState({ errorMessage: data.name[0] });
            window.location.href = "/app/instance/sharedvm";
          }
        }
      })
      .catch((error) => {
        window.location.reload();
      });
  };
  var value = JSON.stringify(state);

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Technology
            state={state}
            onState={setState}
            handleNext={handleNext}
            lablist={lablist}
          />
        );
      case 1:
        return (
          <Configurations
            value={value}
            onState={setState}
            activeStep={activeStep}
            handleBack={handleBack}
            handleNext={handleNext}
            stepslength={steps.length}
          />
        );
      case 2:
        return (
          <Schedule
            statevalue={value}
            onState={setState}
            activeStep={activeStep}
            handleBack={handleBack}
            handleNext={handleNext}
            stepslength={steps.length}
          />
        );
      case 3:
        return (
          <Notification
            onState={setState}
            activeStep={activeStep}
            depends_on={state.depends_on}
            start_date={state.start_date}
            end_date={state.end_date}
            numberOfTrainee={state.nooftrainee}
            handleBack={handleBack}
            handleNext={handleNext}
            stepslength={steps.length}
          />
        );
      case 4:
        return (
          <Review
            state={state}
            activeStep={activeStep}
            name={state.name}
            number_of_trainee={state.nooftrainee}
            description={state.description}
            billing_info={state.billing_info}
            start_date={state.start_date}
            end_date={state.end_date}
            start_time={state.start_time}
            stop_time={state.end_time}
            depends_on={state.depends_on}
            repeat_frequency={state.repeat_frequency}
            on_days={state.on_days}
            startcron_expression={state.startcron_expression}
            startcron_expression2={state.startcron_expression2}
            budget={state.budget}
            env_keep_date={state.env_keep_date}
            meeting_url={state.meetingLink}
            budgethours={state.budgethours}
            billingtype={state.billingtype}
            selectedRelatedLabType={state.selectedRelatedLabType}
            selectedMasterLabId={state.selectedMasterLabId}
            identicalPassword={state.identicalpassword}
            handleBack={handleBack}
            handleSubmitClick={handleSubmitClick}
            stepslength={steps.length}
          ></Review>
        );

      // case 4:
      //   return (
      //     <Budget
      //       onState={setState}
      //       activeStep={activeStep}
      //       handleBack={handleBack}
      //       handleSubmitClick={handleSubmitClick}
      //       stepslength={steps.length}
      //     />
      //   );
      default:
        throw new Error("Unknown step");
    }
  };
  const RunningLab = () => {
    window.location.href = "/app/instance/sharedvm";
  };
  const BacktoNew = () => {
    window.location.href = "/app/maindeployment";
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      <Box
        sx={{
          minWidth: "1050",
          paddingRight: "40px",
        }}
      >
        <BudgetError
          validerroropen={budgetopen}
          setvaliderroropen={setBudgetOpen}
        />
        <Typography component="h1" variant="h4" align="center">
          Create Shared Lab
        </Typography>

        <Box sx={{ pt: 2 }}>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Container maxWidth={false}>
          <Box sx={{ pt: 3 }}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                minWidth: "1050",
              }}
            >
              <CardContent>
                <form
                  autoComplete="off"
                  noValidate
                  style={{ paddingRight: "40px", paddingLeft: "20px" }}
                >
                  <React.Fragment>
                    {activeStep === steps.length ? (
                      <React.Fragment>
                        <Typography variant="h5" gutterBottom align="center">
                          <div style={{ height: "40" }}>
                            <DoneIcon style={{ fontSize: "xx-large" }} />{" "}
                            <span style={{ color: "green", fontSize: "30px" }}>
                              Successful !!!
                            </span>
                          </div>
                        </Typography>
                        <Typography variant="subtitle1" align="center">
                          Instance will be ready to use within 10 mins!!!
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            pt: 2,
                            paddingLeft: "30px",
                          }}
                        >
                          <div
                            className={classes}
                            style={{ paddingRight: "10px" }}
                          >
                            <Tooltip title="Go back to create a new request">
                              <span>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className={classes}
                                  onClick={BacktoNew}
                                  sx={{ borderRadius: '50px', mr: 1 }}
                                >
                                  <NavigateBeforeIcon />
                                  Back
                                </Button>
                              </span>
                            </Tooltip>
                          </div>
                          <div className={classes}>
                            <Tooltip title="Open running labs">
                              <span>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className={classes}
                                  onClick={RunningLab}
                                  sx={{ borderRadius: '50px' }}
                                >
                                  Go to Running labs
                                </Button>
                              </span>
                            </Tooltip>
                          </div>
                        </Box>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        {getStepContent(activeStep)}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                </form>
              </CardContent>
            </Card>
          </Box>
        </Container>
      </Box>
    </React.Fragment>
  );
}
